import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';

import CoachingModalFooter from '../../../../components/coachingModalFooter/CoachingModalFooter';
import ReadConversationModalBody from '../../../../components/readConversationModalBody/ReadConversationModalBody';
import { ConversationLogProps } from '../types';
import ReadConversationModalHeader from './readConversationModalHeader/ReadConversationModalHeader';

const ReadConversationLog = (props: ConversationLogProps) => {
    const [first, setFirst] = useState(0);
    const [commentView, setCommentView] = useState(false);
    const [conversationList, setConversationList] = useState<any[]>([]);
    const [isResponse, setIsResponse] = useState<boolean>(false);
    const [convId, setConvId] = useState<number>(0);
    const [coreValueId, setCoreValueId] = useState<number>(0);

    useEffect(() => {
        setIsResponse(conversationList[first]?.response_description?.trim()?.length > 0);
        if (conversationList.length - 1 < first)
            setFirst(conversationList.length - 1 > 0 ? conversationList.length - 1 : 0);
    }, [conversationList, first]);

    const onPageChange = (event: any) => {
        if (conversationList?.length < first || conversationList?.length === undefined) setFirst(0);
        else setFirst(event.first);
    };
    const noMatch = () => {
        return <div className="noMatch">There are no discussions to display.</div>;
    };
    const handleSaveClicked = (convIds: number[]) => {
        setConvId(convIds[first]);
    };
    useEffect(() => {
        if (conversationList) {
            const convIds: number[] = [];
            const coreValueIds: number[] = [];

            conversationList.forEach((item: any) => {
                const currentConvId = item.coaching_conversation_id || 0;
                let currentCoreValueId = 0;

                if (item.core_value_abbreviation === 'Lead') {
                    currentCoreValueId = 1;
                } else if (item.core_value_abbreviation === 'Right Thing') {
                    currentCoreValueId = 2;
                } else if (item.core_value_abbreviation === 'Amazing') {
                    currentCoreValueId = 3;
                } else if (item.core_value_abbreviation === 'Understand') {
                    currentCoreValueId = 4;
                } else if (item.core_value_abbreviation === 'Act As One') {
                    currentCoreValueId = 5;
                } else if (item.core_value_abbreviation === 'Live Life') {
                    currentCoreValueId = 6;
                }
                convIds.push(currentConvId);
                coreValueIds.push(currentCoreValueId);
            });
            handleSaveClicked(convIds)
            // Pass the arrays to the parent component after the loop            
           handleCoreValueId(coreValueIds);
        }
    }, [first]);

    const handleCoreValueId = (coreValueIds: number[]) => {
        setCoreValueId(coreValueIds[first]); // Use the value corresponding to the currently displayed conversation
        // Handle the array of coreValueIds as needed
    };

    return (
        <Dialog
            header={
                <ReadConversationModalHeader
                    setViewState={props.setViewState}
                    setConversationList={setConversationList}
                    isRecipient={(props?.authorId === props?.recieverId || props?.isRecipient) || false}
                    receiverId={props?.recieverId}
                    authorId={props?.authorId}
                    inputMonth={props?.inputMonth}
                    inputYear={props?.inputYear}
                    onSaveClicked={handleSaveClicked}
                    handleCoreValueId={handleCoreValueId}
                    via={props.via}
                    coachingEntityId={props.coachingEntityId}
                />
            }
            footer={<CoachingModalFooter list={conversationList} first={first} onPageChange={onPageChange} />}
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="top-right"
            visible={props.displayModal}
            onHide={() => {
                props.setDisplayModal(false);
                props.setViewState('read');
            }}
            className="card shadow bg-body rounded border-0"
            modal
            draggable={false}
            resizable={false}
        >
            {conversationList?.length > 0 ? (
                <ReadConversationModalBody
                    listItem={conversationList[first]}
                    commentView={commentView}
                    setCommentView={setCommentView}
                    isResponse={isResponse}
                    setIsResponse={setIsResponse}
                    receiverName={props.receiverName}
                    receiverId={props.recieverId}
                    convId={convId}
                    coreValueId={coreValueId}
                    setDisplayModal={props?.setDisplayModal}
                    readOnly={props?.readOnly}
                />
            ) : (
                noMatch()
            )}
        </Dialog>
    );
};
export default ReadConversationLog;
